// Headers e permissões para tenant Industrial (padrão)
export const headerProfilesTable : string[] = ['Nome do perfil','Certificados','Estoque','Compras','Pedidos','Produção','Roteirização','Acessos', 'Produtos', 'Insumos', 'Serviços', 'Equipamentos', 'Financeiro', 'Fiscal', 'Editar estoque', '']

export const allPermissions : string[] = ['name','certificates','stock','purchase','orders','production','router','accesses', 'products', 'resources', 'services', 'equipment', 'financial', 'fiscal', 'edit-stock', 'delete']

// Headers e permissões específicas para tenant Fashion (tenantId 2)
export const headerProfilesTableFashion : string[] = ['Nome do perfil', 'Acessos', 'Produtos', 'Desenvolvimento de Produto', 'Vendas', 'Produção', 'Compras', 'Financeiro', 'Fiscal', 'Estoque', 'Editar estoque', 'Roteirização', 'Serviços', 'Equipamentos', '']

export const allPermissionsFashion : string[] = ['name', 'accesses', 'products', 'product-development', 'orders', 'production', 'purchase', 'financial', 'fiscal', 'stock', 'edit-stock', 'router', 'services', 'equipment', 'delete']

// Função para obter headers baseado no tenant
export function getHeadersByTenant(tenantId: number): string[] {
  if (tenantId === 2) {
    return headerProfilesTableFashion
  }
  return headerProfilesTable
}

// Função para obter permissões baseado no tenant
export function getPermissionsByTenant(tenantId: number): string[] {
  if (tenantId === 2) {
    return allPermissionsFashion
  }
  return allPermissions
}

export const headerCompanies : string[] = ['CNPJ','Razão social','Inscrição Estadual','Telefone','E-mail','Nome do contato', 'Tipo']

export const companiesFields : string[] = ['cnpj','companyName','stateRegistration','phone','email','contactName', 'companyTypes']